import { Form } from 'formik';
import styled from 'styled-components';
import { FormFloating } from '../../styles/FormStyledComponents';
import { LinkButton, TextBold } from '../../styles/GlobalStyledComponents';

export const ProdTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding: 15px 0;
  line-height: 1.25rem;

  @media (max-width: 450px) {
    padding: 10px 0;
  }
`;

interface EntryFormProps {
  $opacity: number;
  $addedMargin?: string;
}
export const EntryForm = styled(Form)<EntryFormProps>`
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  transition: padding-top 0.75s;
  height: auto;
  transition: all 0.3s ease;
  opacity: ${(props) => props.$opacity};
  @media (max-width: 450px) {
    height: auto;
  }
`;

export const AmountCurrency = styled.span`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ImageEntry = styled.img<EntryFormProps>`
  width: 140px;
  margin: ${(props) => (props.$addedMargin ? props.$addedMargin : 'auto')};
  transition: all 0.3s ease;
  opacity: ${(props) => props.$opacity};
`;

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px 0;
`;

export const SummaryData = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  border: 1px solid #e3e1e1;
  border-radius: 6px;
  padding: 8.5px 10px;
  gap: 5px;
  @media (max-width: 300px) {
    width: 90%;
    padding: 2.5px 3px;
  }
`;

export const TextBoldSpan = styled(TextBold)`
  display: flex;
  align-items: flex-end;
  height: 21px;
  white-space: nowrap;
`;

export const OfferSelectorWrapper = styled.div`
  padding-bottom: 15px;
`;

interface ArrowWrapperProps {
  $isDisabled: boolean;
}

export const ArrowWrapper = styled.div<ArrowWrapperProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* padding: 10px 0; */
  opacity: ${(props) => (props.$isDisabled ? 0.2 : 1)};
  cursor: ${(props) => (props.$isDisabled ? 'default' : 'pointer')};
`;

export const RateListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 96px;
  overflow-y: hidden;
  border-radius: 14px;
  margin: 10px;
  gap: 0.3%;
`;

interface RateDataProps {
  $isSelected: boolean;
}

export const RateData = styled.div<RateDataProps>`
  width: 33%;
  box-shadow: 0px 0px 16px 0px rgba(8, 84, 117, 0.08);
  padding: 10px 10px 0 10px;
  border: 1px solid
    ${(props) =>
      props.$isSelected ? props.theme.colors.red6 : props.theme.colors.gray11};
  background-color: ${(props) =>
    props.$isSelected ? props.theme.colors.red11 : props.theme.colors.white};
  font-weight: ${(props) => (props.$isSelected ? 700 : 400)};
  border-radius: 14px;
  height: 85px;
  margin: 5px 0;
  cursor: pointer;
  &:hover {
    border-color: ${(props) => props.theme.colors.red6};
    background-color: ${(props) => props.theme.colors.red11};
    font-weight: 700;
  }
`;

export const RateText = styled.p`
  font-size: 10px;
  margin: 0;
  text-align: center;
  width: 100%;
  /* text-overflow: ellipsis; */
  /* height: 40px; */
  width: 100%;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  margin-bottom: 4px;
`;

export const RateIconWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const OfferListSelect = styled(FormFloating)`
  position: relative;
`;

export const ImageIconBank = styled.img`
  width: 20px;
  height: auto;
`;
interface ArrowImgProps {
  direction?: string;
}

export const ArrowImg = styled.img<ArrowImgProps>`
  width: 20px;
  transform: ${(props) =>
    props.direction ? 'rotate(180deg) scaleX(-1);' : ''};
`;

export const TermSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const TermSelector = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 10px 10px;

  @media (max-width: 450px) {
    padding: 0 0 10px 0;
  }
`;

interface TermSelectorProps {
  disable: string;
}
export const TermSelectorButton = styled.div<TermSelectorProps>`
  cursor: ${(props) => (props.disable ? 'not-allowed' : 'pointer')};
  background: ${(props) => (props.disable ? '#ccf1e4' : '#00b87a')} 0% 0%
    no-repeat padding-box;
  color: #fff;
  /* min-width: 30px;
  height: 30px; */
  border-radius: 100%;
  margin: auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
`;

export const ImageIcon = styled.img`
  width: 60%;
`;

export const TermSelected = styled.div`
  font-size: 42px;
  font-weight: 700;
  min-width: 80px;
  text-align: center;
  margin-top: 10px;
  margin-right: 0.25rem;
  margin-left: 0.25rem;
`;

export const TodayHighlight = styled.div`
  background: #00b87a 0% 0% no-repeat padding-box;
  border-radius: 17px;
  padding: 0px 10px;
  margin-right: 2px;
  height: fit-content;
`;

export const TodayHighlightText = styled.span`
  color: white;
  font-weight: 500;
  font-size: 14px;
`;

export const FirstFeeText = styled.span`
  font-weight: 500;
  font-size: 14px;
`;

export const FirstFee = styled.span`
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

export const RegularFeeText = styled.span`
  font-size: 12px;
  font-weight: 500;
`;

export const DetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 1rem;
`;

export const DetailsPlaceholder = styled.div`
  display: flex;
  margin: 0;
  padding: 0;
  width: 100%;
  justify-content: space-between;
  margin-top: 1rem;
`;

export const DetailsTitle = styled.span`
  text-transform: uppercase;
  color: #acb2c3;
  font-size: 12px;
  font-weight: 400;
`;

export const DetailsSectionTitle = styled.span`
  font-size: 12px;
  font-weight: 700;
`;

export const DetailsSectionSubtitle = styled.span`
  font-size: 10px;
  font-weight: 400;
  padding: 5px 0;
`;

export const DetailsSectionAmount = styled.span`
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
`;

export const DetailsSectionAmountIcon = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.gray9};
  margin-left: 10px;
`;

export const EditIcon = styled.img`
  width: 14px;
  margin-right: 10px;
  padding-bottom: 4px;
  cursor: pointer;
  @media (max-width: 300px) {
    margin: 0;
  }
`;

export const InfoLink = styled(LinkButton)`
  text-decoration: none;
  padding-right: 1.5rem;
`;
interface WrapperBoxProps {
  showinfo?: string;
}

export const WrapperBox = styled.div<WrapperBoxProps>`
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  padding: 9px 13px;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.border};
  width: 100%;
  overflow: hidden;
  transition: height 0.35s ease;
  ${({ showinfo }) =>
    showinfo &&
    `
        height: ${showinfo === 'open' ? '150px' : '75px'};
    `}
  ${({ showinfo }) =>
    !showinfo &&
    `
      height: 91.5px;
      overflow: unset;
    `}
  @media (max-width: 332px) {
    ${({ showinfo }) =>
      showinfo &&
      `
        height: ${showinfo === 'open' ? '165px' : '90px'};
    `}
  }
`;

export const CustomWrapperBox = styled(WrapperBox)`
  height: auto;
`;

interface WrapperBoxSectionProps {
  margin?: string;
}
export const WrapperBoxSection = styled.div<WrapperBoxSectionProps>`
  display: flex;
  justify-content: space-between;
  margin: ${(props) => props.margin};
`;

export const WrapperBoxElement = styled.div`
  display: flex;
  align-items: center;
  padding: 3px 0;
`;

export const WrapperBoxElementAmount = styled.div`
  display: flex;
  align-items: center;
  padding: 3px 0;
  background-color: #ffffff;
  padding: 8px 15px 4px;
  border: 1px solid ${(props) => props.theme.colors.gray9};
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 5px;
  @media (max-width: 330px) {
    padding: 8px 12px 4px;
  }
`;

export const WrapperBoxInfo = styled.div``;

export const DetailSpecialSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const DetailsInfo = styled.div``;
